var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1176 16.1429H15C14.6471 14.8571 13.5 14 12.0882 14C10.4118 14 9 15.3714 9 17C9 18.6286 10.4118 20 12.0882 20C13.5 20 14.6471 19.1429 15 17.8571H17.1176C17.6471 17.8571 18 17.4286 18 17C18 16.4857 17.6471 16.1429 17.1176 16.1429Z",
    fill: "#DADEE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14894 16H0.851064C0.340425 16 0 16.5 0 17C0 17.6 0.425532 18 0.851064 18H7.14894C7.65957 18 8 17.5 8 17C8 16.4 7.57447 16 7.14894 16Z",
    fill: "#DADEE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.851064 4H7.14894C7.65957 4 8 3.5 8 3C8 2.5 7.57447 2 7.14894 2H0.851064C0.340425 2 0 2.5 0 3C0 3.5 0.425532 4 0.851064 4Z",
    fill: "#DADEE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0882 6C13.5 6 14.6471 5.14286 15 3.85714H17.1176C17.6471 3.85714 18 3.42857 18 3C18 2.57143 17.5588 2.14286 17.1176 2.14286H15C14.6471 0.857143 13.5 0 12.0882 0C10.4118 0 9 1.37143 9 3C9 4.62857 10.4118 6 12.0882 6Z",
    fill: "#DADEE6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.882353 10.8571H3C3.35294 12.0571 4.5 13 5.91176 13C7.58824 13 9 11.6286 9 10C9 8.37143 7.58824 7 5.91176 7C4.5 7 3.35294 7.85714 3 9.14286H0.882353C0.352941 9.14286 0 9.57143 0 10C0 10.4286 0.441176 10.8571 0.882353 10.8571Z",
    fill: "#DADEE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1398 9H10.8602C10.3441 9 10 9.5 10 10C10 10.5 10.4301 11 10.8602 11H17.1398C17.6559 11 18 10.5 18 10C18 9.5 17.6559 9 17.1398 9Z",
    fill: "#DADEE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.de6bd2c5b2aa74db01cbbd614737ce2d.svg";
export { ForwardRef as ReactComponent };